// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__YuldC","label":"Section_label__1z-PN","contentWrap":"Section_contentWrap__tFj2P","footer":"Section_footer__dC63Q","footerInner":"Section_footerInner__Xh8IH"};